import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchDonationCampaigns,
  fetchDonationTransactions,
  createDonation,
} from "../redux/slices/donationSlice";

type Props = {
  onClose: () => void;
  clientId: number;
  contactId: number;
};

const DonationModal: React.FC<Props> = ({ onClose, clientId, contactId }) => {
  const dispatch = useDispatch<any>();

  const { campaigns, transactions, loading, submitLoading } = useSelector(
    (state: any) => state.donation
  );

  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("upi");
  const [campaignId, setCampaignId] = useState("");

  const fetchData = () => {
    dispatch(fetchDonationCampaigns(clientId));
    dispatch(
      fetchDonationTransactions({
        client_id: clientId,
        contact_id: contactId,
      })
    );
  };

  useEffect(() => {
    if (clientId && contactId) {
      fetchData();
    }
  }, [clientId, contactId]);

  const submitDonation = async () => {
    if (!amount || Number(amount) <= 0) {
      alert("Enter valid amount");
      return;
    }

    const res = await dispatch(
      createDonation({
        client_id: clientId,
        contact_id: contactId,
        campaign_id: campaignId || null,
        amount: Number(amount),
        payment_mode: paymentMode,
        remarks: "Donation from header button",
      })
    );

    if (createDonation.fulfilled.match(res) && res.payload.status === true) {
      alert("Donation saved successfully");
      setAmount("");
      setCampaignId("");
      fetchData();
    } else {
      alert(res.payload?.message || "Donation failed");
    }
  };

  return (
    <div className="donation-modal-overlay">
      <div className="donation-modal">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-700 mb-0">Donate Now</h4>
          <button onClick={onClose} className="btn btn-sm btn-light">
            ✕
          </button>
        </div>

        <div className="mb-3">
          <label className="fw-600 font-xssss">Campaign</label>
          <select
            className="form-control"
            value={campaignId}
            onChange={(e) => setCampaignId(e.target.value)}
          >
            <option value="">General Donation</option>
            {campaigns.map((item: any) => (
              <option key={item.campaign_id} value={item.campaign_id}>
                {item.title || item.campaign_name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="fw-600 font-xssss">Amount</label>
          <input
            type="number"
            className="form-control"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="fw-600 font-xssss">Payment Mode</label>
          <select
            className="form-control"
            value={paymentMode}
            onChange={(e) => setPaymentMode(e.target.value)}
          >
            <option value="upi">UPI</option>
            <option value="cash">Cash</option>
            <option value="bank">Bank</option>
            <option value="card">Card</option>
          </select>
        </div>

        <button
          onClick={submitDonation}
          disabled={submitLoading}
          className="btn btn-primary w-100 rounded-xl"
        >
          {submitLoading ? "Saving..." : "Submit Donation"}
        </button>

        <hr />

        <h5 className="fw-700">Donation Campaigns</h5>

        {loading ? (
          <p className="text-grey-500 font-xssss">Loading...</p>
        ) : campaigns.length === 0 ? (
          <p className="text-grey-500 font-xssss">No campaigns found</p>
        ) : (
          campaigns.map((item: any) => (
            <div key={item.campaign_id} className="p-2 border rounded mb-2">
              <b>{item.title || item.campaign_name}</b>
              <p className="mb-0 font-xssss">{item.description}</p>
              <small>
                Target: ₹{item.target_amount || 0} | Collected: ₹
                {item.collected_amount || 0}
              </small>
            </div>
          ))
        )}

        <hr />

        <h5 className="fw-700">Old Donation Transactions</h5>

        {transactions.length === 0 ? (
          <p className="text-grey-500 font-xssss">No donations yet</p>
        ) : (
          transactions.map((t: any) => (
            <div
              key={t.transaction_id}
              className="d-flex justify-content-between border-bottom py-2 font-xssss"
            >
              <span>₹{t.amount}</span>
              <span>{t.payment_mode}</span>
              <span>{t.transaction_date || t.created_at}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DonationModal;